import { IChargeTypeBehavior } from '../interfaces/plans';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../translations/manageCollaborators';
import { TRANSLATION_MY_PLAN } from '../translations/plan';
import { ChargeType } from '../types/types';

const CHECKOUT_TRANSLATIONS = TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.checkout;

export const DEFAULT_CHARGE_TYPE_BEHAVIOR: IChargeTypeBehavior = {
  enforcesLicenseCap: false,
  showLicensesTitle: false,
  licensesRow: 'counter',
  totalCard: 'hidden'
};

export const CHARGE_TYPE_BEHAVIOR: Record<ChargeType, IChargeTypeBehavior> = {
  active_user: {
    enforcesLicenseCap: false,
    showLicensesTitle: true,
    licensesRow: 'counter',
    totalCard: 'incremental',
    totalDescriptionKey: CHECKOUT_TRANSLATIONS.checkoutDescription,
    infoKey: CHECKOUT_TRANSLATIONS.chargeTypes.nomina,
    priceLabelKey: TRANSLATION_MY_PLAN.perCollaborator
  },
  onboarded_users: {
    enforcesLicenseCap: false,
    showLicensesTitle: false,
    licensesRow: 'cost-per-user',
    totalCard: 'hidden',
    infoKey: CHECKOUT_TRANSLATIONS.chargeTypes.onboarding,
    priceLabelKey: TRANSLATION_MY_PLAN.perCollaborator
  },
  no_charge: {
    enforcesLicenseCap: false,
    showLicensesTitle: true,
    licensesRow: 'counter',
    totalCard: 'zero',
    totalDescriptionKey: CHECKOUT_TRANSLATIONS.checkoutDescription,
    infoKey: CHECKOUT_TRANSLATIONS.chargeTypes.freePlan,
    priceLabelKey: TRANSLATION_MY_PLAN.perCollaborator
  },
  exceed_licenses: {
    enforcesLicenseCap: false,
    showLicensesTitle: true,
    licensesRow: 'cap',
    totalCard: 'incremental',
    totalDescriptionKey: CHECKOUT_TRANSLATIONS.checkoutDescription,
    infoKey: CHECKOUT_TRANSLATIONS.chargeTypes.exceedsLicenseses,
    priceLabelKey: TRANSLATION_MY_PLAN.perCollaborator
  },
  fixed_licenses: {
    enforcesLicenseCap: true,
    showLicensesTitle: true,
    licensesRow: 'cap',
    totalCard: 'incremental',
    totalDescriptionKey: CHECKOUT_TRANSLATIONS.checkoutDescription,
    infoKey: CHECKOUT_TRANSLATIONS.chargeTypes.notExceedsLicenses,
    priceLabelKey: TRANSLATION_MY_PLAN.perCollaborator
  },
  monthly_fixed: {
    enforcesLicenseCap: false,
    showLicensesTitle: false,
    licensesRow: 'none',
    totalCard: 'zero',
    totalDescriptionKey: CHECKOUT_TRANSLATIONS.fixedChargeDescription,
    infoKey: CHECKOUT_TRANSLATIONS.chargeTypes.monthlyFixed,
    priceLabelKey: TRANSLATION_MY_PLAN.perMonth
  }
};

export const getChargeTypeBehavior = (chargeType?: ChargeType | string): IChargeTypeBehavior =>
  chargeType && Object.prototype.hasOwnProperty.call(CHARGE_TYPE_BEHAVIOR, chargeType)
    ? CHARGE_TYPE_BEHAVIOR[chargeType as ChargeType]
    : DEFAULT_CHARGE_TYPE_BEHAVIOR;
